var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minimize (1) 1",
    clipPath: "url(#clip0_6286_21869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66667 12.5H1.66667C1.16667 12.5 0.833333 12.8333 0.833333 13.3333C0.833333 13.8333 1.16667 14.1667 1.66667 14.1667H4.66667L0.25 18.5833C-0.0833333 18.9167 -0.0833333 19.4167 0.25 19.75C0.583333 20.0833 1.08333 20.0833 1.41667 19.75L5.83333 15.3333V18.3333C5.83333 18.8333 6.16667 19.1667 6.66667 19.1667C7.16667 19.1667 7.5 18.8333 7.5 18.3333V13.3333C7.5 12.8333 7.16667 12.5 6.66667 12.5Z",
    fill: "#4B5C68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3333 14.1667H18.3333C18.8333 14.1667 19.1667 13.8333 19.1667 13.3333C19.1667 12.8333 18.8333 12.5 18.3333 12.5H13.3333C12.8333 12.5 12.5 12.8333 12.5 13.3333V18.3333C12.5 18.8333 12.8333 19.1667 13.3333 19.1667C13.8333 19.1667 14.1667 18.8333 14.1667 18.3333V15.3333L18.5833 19.75C18.9167 20.0833 19.4167 20.0833 19.75 19.75C20.0833 19.4167 20.0833 18.9167 19.75 18.5833L15.3333 14.1667Z",
    fill: "#4B5C68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3333 7.5H18.3333C18.8333 7.5 19.1667 7.16667 19.1667 6.66667C19.1667 6.16667 18.8333 5.83333 18.3333 5.83333H15.3333L19.75 1.41667C20.0833 1.08333 20.0833 0.583333 19.75 0.25C19.4167 -0.0833333 18.9167 -0.0833333 18.5833 0.25L14.1667 4.66667V1.66667C14.1667 1.16667 13.8333 0.833333 13.3333 0.833333C12.8333 0.833333 12.5 1.16667 12.5 1.66667V6.66667C12.5 7.16667 12.8333 7.5 13.3333 7.5Z",
    fill: "#4B5C68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.66667 0.833333C6.16667 0.833333 5.83333 1.16667 5.83333 1.66667V4.66667L1.41667 0.25C1.08333 -0.0833333 0.583333 -0.0833333 0.25 0.25C-0.0833333 0.583333 -0.0833333 1.08333 0.25 1.41667L4.66667 5.83333H1.66667C1.16667 5.83333 0.833333 6.16667 0.833333 6.66667C0.833333 7.16667 1.16667 7.5 1.66667 7.5H6.66667C7.16667 7.5 7.5 7.16667 7.5 6.66667V1.66667C7.5 1.16667 7.16667 0.833333 6.66667 0.833333Z",
    fill: "#4B5C68"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6286_21869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.b74587a9f1f6a00bbc80922995cda4bf.svg";
export { ForwardRef as ReactComponent };